// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"082e5875","253":"409c7333","295":"235af90f","313":"91a0e5ff","438":"f3cc3239","518":"211d31b9","551":"33ff0765","896":"59f6b0e1"}[chunkId] + ".chunk.js";
};